<template>
  <main id="input">
      <Menu />
      <transition name="fade">
          <GroupPersistance v-if="groupPersistance" />
      </transition>
      <p class="count">{{listSize}} pers</p>
      <Form />
  </main>
</template>
<script>
import Form from '@/components/Form';
import Menu from '@/components/Menu';
import GroupPersistance from '@/views/GroupPersistance';

export default {
    name: 'Input',
    components: {
        Form,
        Menu,
        GroupPersistance
    },
    computed: {
        listSize(){
            return this.$store.state.roster.length;
        },
        groupPersistance(){
            return this.$store.state.UIstate.groupPersistance;
        }
    },
    beforeMount(){
      this.$store.commit('configMenuUI', { 
        close: false, 
        back: false,
        navicon: true,
        crossGroups: false,
        remix: false,
        screenshot: false,
        share: false  
        })
    }
}
</script>

<style lang="scss">
@import './../scss/variables';

#input {
    background: $groupieGradient;
    @include center;
    flex-direction: column;
    padding: 1rem;

    .count {
        max-width: 24rem;
        width: 100%;
        color: white;
        font-size: $font-sml;
    }
}
</style>